!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.EventEmitter = e() : t.EventEmitter = e();
}(this, function () {
  return function () {
    "use strict";

    var t = {
      660: function _(t, e) {
        e.__esModule = !0, e.EventEmitter = void 0;

        var n = function () {
          function t(t) {
            this._events = Object.create(null), this.catchHandler = t || function () {};
          }

          return t.prototype.hasListeners = function (t) {
            return !(!this._events[t] || !this._events[t].length);
          }, t.prototype.getActiveEvents = function () {
            var t = this;
            return Object.keys(this._events).filter(function (e) {
              return t.hasListeners(e);
            });
          }, t.prototype.trigger = function (t, e) {
            var n = this;
            this._events[t] && (this._events[t].slice().forEach(function (o) {
              try {
                o.handler.call(o.context, e);
              } catch (t) {
                n.catchHandler(t);
              }

              o.once && n.off(t, o.handler);
            }), this._events[t].length || delete this._events[t]);
          }, t.prototype.on = function (t, e, n) {
            this._on(t, e, n, !1);
          }, t.prototype.once = function (t, e, n) {
            this._on(t, e, n, !0);
          }, t.prototype.off = function (t, e) {
            var n = this,
                o = "string" == typeof t ? t : null,
                i = "function" == typeof e ? e : "function" == typeof t ? t : null;
            if (o) {
              if (i) {
                if (o in this._events) {
                  var r = this._events[o].map(function (t) {
                    return t.handler;
                  }).indexOf(i);

                  this._events[o].splice(r, 1);
                }
              } else delete this._events[o];
            } else Object.keys(this._events).forEach(function (t) {
              n.off(t, i);
            });
          }, t.prototype._on = function (t, e, n, o) {
            this._events[t] || (this._events[t] = []), this._events[t].push({
              handler: e,
              context: n,
              once: o
            });
          }, t;
        }();

        e.EventEmitter = n;
      },
      607: function _(t, e, n) {
        var o = this && this.__createBinding || (Object.create ? function (t, e, n, o) {
          void 0 === o && (o = n), Object.defineProperty(t, o, {
            enumerable: !0,
            get: function get() {
              return e[n];
            }
          });
        } : function (t, e, n, o) {
          void 0 === o && (o = n), t[o] = e[n];
        }),
            i = this && this.__exportStar || function (t, e) {
          for (var n in t) {
            "default" === n || Object.prototype.hasOwnProperty.call(e, n) || o(e, t, n);
          }
        };

        e.__esModule = !0;
        var r = n(660);
        i(n(660), e), e.default = r.EventEmitter;
      }
    },
        e = {};
    return function n(o) {
      if (e[o]) return e[o].exports;
      var i = e[o] = {
        exports: {}
      };
      return t[o].call(i.exports, i, i.exports, n), i.exports;
    }(607);
  }();
});